import { TabBtns } from "../../Theme";
import { useNavigate } from "react-router-dom";
import { YSButton } from "../../uikit/YSButton";

export default function PendingRxChangeTab(props: any) {
  const navigate = useNavigate();
  return (
    <>
      <TabBtns>
        <YSButton
          className={!props.activeRxChangeTabClass ? "active tab" : "tab "}
          children={"Prescription Rx Change"}
          variant={"text"}
          size={"small"}
          onClick={() => {
            navigate("/pendingrxchangerequest");
            props.setActiveRxChangeTabClass(false);
          }}
        />
        <YSButton
          className={props.activeRxChangeTabClass ? "active tab" : "tab "}
          children={"Allergy Information"}
          variant={"text"}
          size={"small"}
          onClick={() => {
            navigate("/pendingrxchangerequest");
            props.setActiveRxChangeTabClass(true);
          }}
        />{" "}
      </TabBtns>
    </>
  );
}
